/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownRightIcon24Solid = forwardRef('ArrowShapeADownRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18.124 20.751a2.625 2.625 0 0 0 2.625-2.625V5.313c0-1.337-1.615-2.006-2.56-1.061l-2.97 2.97-4.253-4.253a2.25 2.25 0 0 0-3.182 0L2.968 7.785a2.25 2.25 0 0 0 0 3.182l4.253 4.252L4.25 18.19c-.945.945-.276 2.56 1.06 2.56l12.814.001Z" })));
});
